import reactStringReplace from "react-string-replace";
import { useAppContext } from "../../_context";

const HighlightedString = ({ text }) => {
  const [{ tx }] = useAppContext();

  return (
    <>
      {reactStringReplace(text, /(\[[^\]]+\])/, (match, i) => (
        <span key={i} className="text-primary">
          {tx[match]}
        </span>
      ))}
    </>
  );
};

export default HighlightedString;
